import { Button, Result } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { clearLastVisitedDashboard } from 'utils/sessionFilterStoreUtil';

const PageNotFound = () => {

    const history = useHistory();

    return <Result
                className="page-not-found-result"
                status="404"
                title="404"
                subTitle="Sorry, the page you visited does not exist. It might be deleted or moved to some other place or your access has been revoked."
                extra={<Button type="primary" onClick={() => {
                    clearLastVisitedDashboard();
                    history.push('/');
                }}>Back Home</Button>}
            />
}

export default PageNotFound;
